export const REQUEST_LOAD_WORKOUT_EVENTS = 'events/REQUEST_LOAD_WORKOUT_EVENTS';
export const REQUEST_CREATE_WORKOUT_EVENT = 'events/REQUEST_CREATE_WORKOUT_EVENT';
export const REQUEST_UPDATE_WORKOUT_EVENT = 'events/REQUEST_UPDATE_WORKOUT_EVENT';
export const REQUEST_CREATE_WORKOUT_EVENT_RESULT = 'events/REQUEST_CREATE_WORKOUT_EVENT_RESULT';
export const REQUEST_REMOVE_ALL_EVENT_RESULTS = 'events/REQUEST_REMOVE_ALL_EVENT_RESULTS';
export const REQUEST_LOAD_FULL_WORKOUT_EVENT = 'events/REQUEST_LOAD_FULL_WORKOUT_EVENT';
export const REQUEST_FINISH_EVENT = 'events/REQUEST_FINISH_EVENT';
